"use strict";

var React = require("./react");
var _ = require("./utils/mindash");
var uuid = require("./utils/uuid");
var Instances = require("./instances");
var StoreObserver = require("./storeObserver");
var reservedKeys = ["listenTo", "getState", "getInitialState"];

function StateMixin(options) {
  var config, instanceMethods;

  if (!options) {
    throw new Error("The state mixin is expecting some options");
  }

  if (isStore(options)) {
    config = storeMixinConfig(options);
  } else {
    config = simpleMixinConfig(options);
    instanceMethods = _.omit(options, reservedKeys);
  }

  var mixin = _.extend({
    contextTypes: {
      marty: React.PropTypes.object
    },
    componentDidMount: function componentDidMount() {
      var component = {
        id: this.__id,
        displayName: this.displayName || this.constructor.displayName };

      Instances.add(this, {
        observer: new StoreObserver({
          component: component,
          stores: config.stores,
          onStoreChanged: this.onStoreChanged
        })
      });
    },
    onStoreChanged: function onStoreChanged() {
      this.setState(this.getState());
    },
    componentWillUnmount: function componentWillUnmount() {
      var instance = Instances.get(this);

      if (instance) {
        if (instance.observer) {
          instance.observer.dispose();
        }

        Instances.dispose(this);
      }
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
      var oldProps = this.props;
      this.props = nextProps;

      var newState = this.getState();

      this.props = oldProps;
      this.setState(newState);
    },
    getState: function getState() {
      return config.getState(this);
    },
    getInitialState: function getInitialState() {
      var el = this._currentElement;

      if (!this.displayName && el && el.type) {
        this.displayName = el.type.displayName;
      }

      this.state = {};
      this.__id = uuid.type("Component");

      if (options.getInitialState) {
        this.state = options.getInitialState();
      }

      this.state = _.extend(this.state, this.getState());

      return this.state;
    }
  }, instanceMethods);

  return mixin;

  function storeMixinConfig(store) {
    return {
      stores: [store],
      getState: function getState() {
        return store.getState();
      }
    };
  }

  function simpleMixinConfig(options) {
    var stores = options.listenTo || [];
    var storesToGetStateFrom = findStoresToGetStateFrom(options);

    if (!_.isArray(stores)) {
      stores = [stores];
    }

    if (!areStores(stores)) {
      throw new Error("Can only listen to stores");
    }

    stores = stores.concat(_.values(storesToGetStateFrom));

    return {
      stores: stores,
      getState: getState
    };

    function getState(view) {
      var state = _.object(_.map(storesToGetStateFrom, getStateFromStore));

      if (options.getState) {
        state = _.extend(state, options.getState.call(view));
      }

      return state;

      function getStateFromStore(store, name) {
        return [name, store.getState()];
      }
    }

    function findStoresToGetStateFrom(options) {
      var storesToGetStateFrom = {};
      _.each(options, function (value, key) {
        if (reservedKeys.indexOf(key) === -1 && isStore(value)) {
          storesToGetStateFrom[key] = value;
        }
      });

      return storesToGetStateFrom;
    }
  }

  function areStores(stores) {
    for (var i = stores.length - 1; i >= 0; i--) {
      if (!isStore(stores[i])) {
        return false;
      }
    }
    return true;
  }

  function isStore(store) {
    return store.getState && store.addChangeListener;
  }
}

module.exports = StateMixin;


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/stateMixin.js
 ** module id = 463
 ** module chunks = 0
 **/